var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSdr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.85,196s15.69,82.8,15.7,83.6-1.2,68.51-.09,79.34,6.13,76.3,6.13,76.3h3.26l-4-111.4L320.77,271l-13.16-66.06Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.29,303.3a35.06,35.06,0,0,1-23.8-44.92c2.36-7,6.89-13.19,8.83-20.32,2.21-8.1.9-16.7-.47-25s-2.75-16.85-.68-25,8.58-15.78,17-16.35C81.9,171.2,89.07,177,92.32,184s3.26,15.2,2.5,23-2.23,15.49-1.77,23.26c.94,15.74,9.76,30.55,8.72,46.28-.54,8.19-3.71,13.43-9.13,19.59-4.68,5.32-12.46,8.81-19.35,7.18",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.78,342.46c-.12,0-.21-28.4-.21-63.43s.09-63.44.21-63.44S75,244,75,279,74.9,342.46,74.78,342.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.88,265.89c.07.09-3,2.62-6.88,5.64s-7.06,5.39-7.13,5.3,3-2.62,6.87-5.64S88.8,265.8,88.88,265.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.79,264.06a31.88,31.88,0,0,1-4.33-2.73,30.08,30.08,0,0,1-4.09-3.09A31.41,31.41,0,0,1,70.7,261,30.55,30.55,0,0,1,74.79,264.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.66,
    cy: 248.79,
    r: 23.3,
    transform: "translate(24.11 528.04) rotate(-76.72)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,301a2.19,2.19,0,0,1,0-.53c0-.41,0-.91-.05-1.52,0-1.4-.06-3.3-.1-5.61-.07-4.8-.18-11.31-.29-18.5s-.16-13.77-.13-18.5c0-2.37,0-4.29.06-5.61,0-.61,0-1.12.05-1.52a2.34,2.34,0,0,1,.05-.54,1.8,1.8,0,0,1,.05.54c0,.4,0,.91.05,1.52,0,1.4.06,3.3.1,5.61.08,4.8.18,11.31.29,18.5s.17,13.76.14,18.5c0,2.37,0,4.28-.07,5.61,0,.61,0,1.11-.05,1.52A1.69,1.69,0,0,1,346.27,301Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.58,251.63a79.72,79.72,0,0,1-8.63,9.61,79.72,79.72,0,0,1,8.63-9.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.26 206.7 419.13 241.25 424.24 241.45 409.73 268.91 417.35 268.91 405.46 293.3 471.93 293.3 457.3 268.91 464.31 268.6 450.28 241.16 455.47 240.85 436.26 206.7",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.91,246.66c.14,0,0,17.94-.22,40.06s-.6,40.07-.74,40.07-.05-17.94.22-40.07S436.76,246.66,436.91,246.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.79,257a81.43,81.43,0,0,1-10.07,8.35A83.87,83.87,0,0,1,446.79,257Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.24 125.85 134.9 189.06 144.26 189.41 117.71 239.64 131.65 239.64 109.9 284.27 231.5 284.27 204.73 239.64 217.56 239.09 191.9 188.88 201.38 188.32 166.24 125.85",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.54,199.17c.14,0-.09,28.87-.51,64.47s-.89,64.46-1,64.46.08-28.86.51-64.47S171.39,199.17,171.54,199.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9,257.08a11.32,11.32,0,0,1-2-.9l-4.81-2.38-4.83-2.33a10.94,10.94,0,0,1-2-1.05,8.8,8.8,0,0,1,2.11.71c1.28.52,3,1.28,4.91,2.2s3.57,1.83,4.76,2.52A8.57,8.57,0,0,1,170.9,257.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92,209.44a3.26,3.26,0,0,1-.46.85c-.32.52-.81,1.27-1.43,2.18-1.23,1.82-3,4.3-5.06,7s-4,5-5.45,6.67c-.72.83-1.32,1.49-1.75,1.93s-.67.69-.7.66a28.16,28.16,0,0,1,2.17-2.83c1.37-1.72,3.27-4.09,5.32-6.75s3.86-5.09,5.17-6.85A27.25,27.25,0,0,1,185.92,209.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.16,
    cy: 210.96,
    r: 37.5,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.41,299.14c-.15,0-.26-19.8-.26-44.21s.11-44.22.26-44.22.26,19.79.26,44.22S378.55,299.14,378.41,299.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.53,215.53c.11.09-2.92,3.64-6.76,7.91s-7,7.66-7.14,7.57a103.12,103.12,0,0,1,6.76-7.92A101,101,0,0,1,392.53,215.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.11 199.83 87.52 239.34 93.37 239.56 76.78 270.96 85.49 270.96 71.9 298.85 147.9 298.85 131.17 270.96 139.18 270.61 123.15 239.23 129.07 238.88 107.11 199.83",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.42,245.66c.14,0,0,16.74-.29,37.37s-.66,37.36-.8,37.36,0-16.73.28-37.37S110.28,245.66,110.42,245.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.74,255.82a53.52,53.52,0,0,1-4.32,6,52.23,52.23,0,0,1-4.73,5.71,53.07,53.07,0,0,1,4.32-6A51.33,51.33,0,0,1,119.74,255.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.24,266.71a27.58,27.58,0,0,1-4.35-3.06,26.41,26.41,0,0,1-4-3.47,27.78,27.78,0,0,1,4.34,3.06A27.46,27.46,0,0,1,110.24,266.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.72,286.09a59.06,59.06,0,0,1-4.86-3.9c-2.66-2.17-4.88-3.85-4.8-4a26.35,26.35,0,0,1,5.13,3.57A27.17,27.17,0,0,1,109.72,286.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.55,274.11a60.28,60.28,0,0,1-4.74,6.3,58.21,58.21,0,0,1-5.14,6,60.28,60.28,0,0,1,4.74-6.3A58.08,58.08,0,0,1,120.55,274.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.7,122.16a4.22,4.22,0,0,0,2.55-3.87,4,4,0,1,0-7.9-.11,4.21,4.21,0,0,0,2.48,4c-6.08.86-5.86,7.46-5.86,7.46l14.36.19S272.72,123.12,266.7,122.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,142.67a3.79,3.79,0,1,1-3.79-3.77A3.79,3.79,0,0,1,350,142.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.8,
    cy: 135.1,
    r: 3.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.61,151.13a3.8,3.8,0,1,1-3.79-4.11A4,4,0,0,1,360.61,151.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.71,150.65c-.16.24-2.68-1.19-5.62-3.19s-5.2-3.82-5-4.06,2.67,1.2,5.62,3.2S355.87,150.41,355.71,150.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,134.83c.18.23-1.77,2-4.34,4s-4.8,3.43-5,3.2,1.76-2,4.33-4S355.84,134.61,356,134.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,81.11a4.71,4.71,0,0,1-.14-1.21,9.83,9.83,0,0,0-.16-1.44,14.72,14.72,0,0,0-.38-1.95,18.42,18.42,0,0,0-2-5A18.68,18.68,0,0,0,375,66.16a18.39,18.39,0,0,0-7.74-3.61,18.58,18.58,0,0,0-9.72.61,17,17,0,0,0-4.72,2.41,19.29,19.29,0,0,0-2.14,1.73,21.74,21.74,0,0,0-1.85,2.09,18.39,18.39,0,0,0-.53,21.79,20.61,20.61,0,0,0,1.75,2.18,19.59,19.59,0,0,0,2.05,1.83,17,17,0,0,0,4.6,2.64,18.5,18.5,0,0,0,17.58-2.15,18.84,18.84,0,0,0,4.91-5.12,18.29,18.29,0,0,0,2.26-4.9,15.6,15.6,0,0,0,.47-1.92,11.06,11.06,0,0,0,.23-1.44,4.68,4.68,0,0,1,.2-1.19,5.55,5.55,0,0,1,0,1.21,8.6,8.6,0,0,1-.13,1.47,13.74,13.74,0,0,1-.39,2,17.91,17.91,0,0,1-2.16,5.1,19.16,19.16,0,0,1-13.16,8.89,19.28,19.28,0,0,1-10.17-1A18.41,18.41,0,0,1,351.5,96a22.83,22.83,0,0,1-2.16-1.92,22,22,0,0,1-1.86-2.3,19.33,19.33,0,0,1,.56-23,20.73,20.73,0,0,1,2-2.2,21.33,21.33,0,0,1,2.25-1.82,18.25,18.25,0,0,1,5-2.5,19.36,19.36,0,0,1,10.21-.54,19.17,19.17,0,0,1,12.72,9.52,17.75,17.75,0,0,1,1.9,5.19,13,13,0,0,1,.3,2,8.68,8.68,0,0,1,.06,1.47A5.77,5.77,0,0,1,382.37,81.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.58,69.27c0,.06-.3.36-1,.85L376.4,71c-.24.17-.5.35-.78.53l-.93.49a21.4,21.4,0,0,1-11.14,2.8l-1.68-.07-1.62-.25c-.27,0-.53-.08-.79-.14l-.75-.2c-.5-.14-1-.25-1.46-.4a24.72,24.72,0,0,1-4.73-2.18c-2.53-1.53-3.77-2.93-3.67-3s1.48,1,4,2.38a28.63,28.63,0,0,0,4.65,1.9c.45.13.92.23,1.4.36l.73.18.75.11,1.55.23,1.6.06a23,23,0,0,0,10.79-2.42l.94-.41c.29-.15.55-.31.8-.45l1.29-.71C378.11,69.4,378.53,69.21,378.58,69.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.27,92.3s.3-.35,1-.84l1.22-.88c.24-.16.49-.35.77-.53l.94-.48a21.36,21.36,0,0,1,11.13-2.81l1.69.08,1.62.25.78.13.76.2c.5.14,1,.26,1.46.41A24.62,24.62,0,0,1,374.32,90c2.54,1.54,3.78,2.94,3.68,3s-1.48-1.06-4-2.38a28.59,28.59,0,0,0-4.65-1.91c-.45-.13-.93-.23-1.41-.35l-.72-.18-.76-.11-1.54-.23-1.61-.07a23.1,23.1,0,0,0-10.78,2.42l-.95.41c-.28.15-.55.32-.8.45l-1.29.72C348.73,92.18,348.31,92.36,348.27,92.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.35,81.55c0,.28-8.49.31-19,.06s-18.93-.7-18.92-1,8.49-.32,18.95-.06S382.36,81.26,382.35,81.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.54,99.57c-.29,0-.31-8.49-.06-18.95s.69-18.92,1-18.92.32,8.49.06,19S362.83,99.58,362.54,99.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.54,99.54c-.07.11-2.16-1.3-4.56-4.51a25.34,25.34,0,0,1-3.39-6.15,22.87,22.87,0,0,1-1.47-8.48A21.92,21.92,0,0,1,355,72a25.91,25.91,0,0,1,3.7-5.95c2.55-3.09,4.65-4.45,4.72-4.34s-1.8,1.67-4.14,4.79a28.15,28.15,0,0,0-3.4,5.89,21.74,21.74,0,0,0-1.75,8,23.16,23.16,0,0,0,1.32,8.13,27.35,27.35,0,0,0,3.09,6.06C360.77,97.83,362.65,99.43,362.54,99.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.89,61.71c.07-.11,2.15,1.3,4.56,4.51a25.6,25.6,0,0,1,3.39,6.14,22.76,22.76,0,0,1,1.46,8.49,21.64,21.64,0,0,1-1.91,8.4,26.34,26.34,0,0,1-3.7,6c-2.55,3.08-4.65,4.45-4.72,4.34s1.8-1.67,4.14-4.79a28.15,28.15,0,0,0,3.4-5.89,21.79,21.79,0,0,0,1.75-8,23.21,23.21,0,0,0-1.32-8.14,27,27,0,0,0-3.09-6C365.66,63.41,363.78,61.82,363.89,61.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.32,157.83h47.17s0-10.8-5.57-10.8a8.56,8.56,0,0,0-8.64,6.69s0-20.15-10.14-17.2c-9.6,2.8-10.69,15.7-10.69,15.7s-1.72-6.48-6.92-2.83S413.32,157.83,413.32,157.83Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.88,97.94h70.59s0-16.16-8.33-16.16a12.84,12.84,0,0,0-12.95,10s0-30.16-15.17-25.74c-14.37,4.19-16,23.5-16,23.5s-2.58-9.71-10.37-4.24S88.88,97.94,88.88,97.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.44,338.31s-.27-.27-.77-.81l-2.21-2.42c-2-2.05-4.94-5.13-9.08-8.7a118.9,118.9,0,0,0-16.06-11.71,112,112,0,0,0-10.93-5.89,107.54,107.54,0,0,0-44.31-10.3,100.43,100.43,0,0,0-35.91,6.09C318,308.93,306.58,316.49,295,324.46c-5.79,4-11.64,8.12-17.8,12a117.9,117.9,0,0,1-19.63,10.17,63.59,63.59,0,0,1-21.6,4.54,69.09,69.09,0,0,1-21.25-2.93,139.84,139.84,0,0,1-19.33-7.5c-6.14-2.85-12-5.87-17.84-8.73-11.56-5.7-22.88-10.72-34.17-12.95-1.4-.29-2.81-.49-4.2-.72l-2.08-.25a18.24,18.24,0,0,0-2.08-.18l-4.1-.22c-1.36,0-2.7.06-4,.08-.66,0-1.33,0-2,.08l-2,.2c-1.29.16-2.58.21-3.84.45l-3.72.67c-1.24.19-2.42.57-3.6.85a93.56,93.56,0,0,0-24.25,10.07,132.92,132.92,0,0,0-16.39,11.25c-4.24,3.44-7.39,6.29-9.48,8.26l-2.37,2.26-.82.76s.26-.28.78-.8l2.33-2.3c2.08-2,5.21-4.86,9.43-8.34a132.88,132.88,0,0,1,16.38-11.35,93.86,93.86,0,0,1,24.3-10.17c1.19-.28,2.37-.66,3.61-.86l3.75-.68c1.26-.24,2.56-.3,3.86-.46l2-.21c.66-.06,1.33-.05,2-.08,1.34,0,2.69-.11,4.06-.09l4.13.21a18.24,18.24,0,0,1,2.08.18l2.1.25c1.4.23,2.82.42,4.23.72,11.35,2.23,22.72,7.25,34.3,12.94,5.8,2.85,11.7,5.86,17.83,8.71a139,139,0,0,0,19.26,7.46A68.83,68.83,0,0,0,236,350.65a63.37,63.37,0,0,0,21.43-4.51A117.63,117.63,0,0,0,277,336c6.15-3.85,12-8,17.79-12,11.54-8,23-15.55,35.26-19.92a100.68,100.68,0,0,1,36.07-6.07,107.62,107.62,0,0,1,44.45,10.43,111,111,0,0,1,10.94,5.94,117,117,0,0,1,16,11.81c4.13,3.59,7,6.7,9,8.78l2.17,2.45C449.2,338,449.44,338.31,449.44,338.31Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.12,435.19l-1.36,0-4,0-15.47.05-57.29.09h-.27l.1-.25c0-.12.09-.26.15-.4v0c.54-3.18,1.14-6.71,1.75-10.34l.31.2-7.95,5.64-.32.22v-.39c0-8.33,0-17.12,0-26.29l.44.06-8.38,29.42-.15.52-.28-.46-7.51-12,.44-.16c.54,4.38,1.13,9.18,1.72,14l0,.28h-.29c-24.12-.11-50.33,0-77.5-.05h-82l-37.09,0H129.45l-2-.11h-.16l0-.16c-.52-3.2-1-6.2-1.48-9.14l.36.09-3.71,5.14-.21.28-.14-.31c-2.15-4.88-4.19-9.48-6.14-13.9l.35-.07c-.14,5.25-.26,10.09-.38,14.7v.31l-.25-.18-8.67-5.9.23-.19,4,9.24.09.2h-.23c-13.54-.13-24.21-.07-31.49-.12l-8.32,0-2.13,0-.72,0,.72,0,2.13,0,8.32,0c7.28,0,18-.1,31.51,0l-.14.2c-1.23-2.82-2.52-5.78-4-9.22l-.22-.5.45.31,8.68,5.87-.27.14c.11-4.61.23-9.45.35-14.7l0-.82.33.75c2,4.41,4,9,6.17,13.88l-.34,0,3.71-5.14.29-.4.08.48c.48,2.95,1,5.94,1.49,9.14l-.19-.18,2,.11h31.69l37.09,0h82c27.18,0,53.38-.05,77.51.07l-.25.28c-.59-4.86-1.18-9.66-1.71-14l-.13-1.09.58.93,7.5,12-.43.06c2.93-10.22,5.74-20.07,8.41-29.41l.44-1.52v1.58c0,9.17,0,18,0,26.29l-.32-.17,8-5.62.39-.27-.08.46c-.62,3.62-1.23,7.15-1.78,10.34h0v0l-.15.4L378,435l57.29.08,15.47.05,4,0C455.66,435.17,456.12,435.19,456.12,435.19Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.8,418c-4.46-2.4-6.26-5.79-7.31-10.75a17.76,17.76,0,0,1,3.3-14.36c2.58-3.34,6.4-5.77,8.17-9.61,1.89-4.09,1.21-9.28,4.08-12.74,2-2.38,5.17-3.33,7.7-5.11,2.06-1.45,3.67-3.45,5.51-5.17s4.1-3.24,6.62-3.34c3.8-.15,7.17,3.21,7.78,7s-1.07,7.62-3.68,10.4c-1.88,2-4.3,3.67-5.4,6.21-2.06,4.76,1.35,10.65-.91,15.32-1.65,3.41-6.05,5.46-6.26,9.24a26.46,26.46,0,0,0,.62,4.12c.47,4.34-3.18,8.29-7.35,9.55s-8.67.43-12.87-.73",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.45,373a2.94,2.94,0,0,1-.39.56c-.31.4-.72.9-1.21,1.54s-1.19,1.46-1.88,2.45-1.54,2.06-2.34,3.35l-1.31,2c-.45.69-.86,1.45-1.31,2.21-.94,1.52-1.79,3.22-2.71,5a91.69,91.69,0,0,0-4.89,12.06,93,93,0,0,0-3,12.66c-.27,2-.56,3.87-.67,5.65-.06.88-.16,1.74-.2,2.57s-.05,1.61-.08,2.37c-.09,1.51,0,2.88,0,4.09s.05,2.24.11,3.08.08,1.46.11,1.95a6,6,0,0,1,0,.69,2.86,2.86,0,0,1-.11-.68c-.05-.49-.12-1.14-.2-1.94s-.18-1.88-.2-3.09-.13-2.59-.07-4.11c0-.76,0-1.56.05-2.38s.12-1.69.17-2.59c.1-1.79.37-3.68.62-5.68A88.62,88.62,0,0,1,419.92,402a87.41,87.41,0,0,1,4.95-12.11c.94-1.78,1.81-3.48,2.76-5,.47-.76.89-1.52,1.35-2.21l1.34-2c.83-1.28,1.7-2.35,2.42-3.31s1.39-1.77,1.95-2.41l1.29-1.48A3.54,3.54,0,0,1,436.45,373Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.84,390.2a8.91,8.91,0,0,1,6.21,3.24,15.75,15.75,0,0,1,3.12,6.43c1.17,4.5.38,9.79-.94,14.25-4.84-1.78-7.8-7-9.13-9.73-2.1-4.32-3.28-13.42.74-14.19",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.18,419.62a7.65,7.65,0,0,1-.29-7.66A10.17,10.17,0,0,1,161,407.1a4.27,4.27,0,0,1,3.59.21,3.25,3.25,0,0,1,1.23,3.07,6.67,6.67,0,0,1-1.42,3.13c-2.39,3.18-5.29,5.82-9.26,6.11",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,435.06a3.85,3.85,0,0,1-.24-.95c-.12-.61-.27-1.51-.43-2.62a32.61,32.61,0,0,1-.23-8.77,16.47,16.47,0,0,1,3.29-8.12,10.77,10.77,0,0,1,1.91-1.87,2.86,2.86,0,0,1,.84-.51,23,23,0,0,0-2.46,2.61,17.23,17.23,0,0,0-3.06,8,37.7,37.7,0,0,0,.07,8.66A28.8,28.8,0,0,1,155.22,435.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.35,397a8.7,8.7,0,0,1,.72,1.45c.43.94,1,2.31,1.76,4,1.45,3.4,3.37,8.14,5.37,13.43s3.69,10.12,4.86,13.63c.58,1.76,1,3.19,1.34,4.18a8.43,8.43,0,0,1,.41,1.55,10.1,10.1,0,0,1-.61-1.49l-1.49-4.12c-1.25-3.48-3-8.29-5-13.57s-3.87-10-5.23-13.48c-.66-1.65-1.2-3-1.61-4.07A10.1,10.1,0,0,1,141.35,397Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.14,424a17.89,17.89,0,0,0-14.35-7.79c-1.44,0-3.15.33-3.71,1.65s.38,2.81,1.42,3.81a15.25,15.25,0,0,0,16.71,2.71",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.27,419.79a3.08,3.08,0,0,1,.94,0,7.28,7.28,0,0,1,1.08.14,11.7,11.7,0,0,1,1.43.29,18.67,18.67,0,0,1,3.56,1.3A22.23,22.23,0,0,1,149.2,424a22.51,22.51,0,0,1,3.25,3.33,19.15,19.15,0,0,1,2,3.23,11,11,0,0,1,.58,1.33,6.35,6.35,0,0,1,.35,1,3.37,3.37,0,0,1,.21.91c-.1,0-.47-1.25-1.47-3.12a21.32,21.32,0,0,0-2.05-3.09,21.15,21.15,0,0,0-7-5.69,20.65,20.65,0,0,0-3.45-1.37C139.59,420,138.26,419.89,138.27,419.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--wifi-cloud--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.07,121.5l68-.1s3.2-26-18.27-23.8c0,0-4.83-17.45-21.2-14.06s-17,20.85-17,20.85S284.17,106.36,285.07,121.5Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.68,112.9a1.55,1.55,0,1,1-1.55-1.54A1.54,1.54,0,0,1,320.68,112.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,110.94a4.3,4.3,0,0,1,6.22-.12.87.87,0,0,0,1.23-1.23,6.05,6.05,0,0,0-8.68.12c-.77.82.46,2.05,1.23,1.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.72,103.76a12.71,12.71,0,0,1,8.3-3.38,12.29,12.29,0,0,1,8.5,3.2c.83.76,2.06-.47,1.24-1.24a14.19,14.19,0,0,0-9.75-3.7,14.57,14.57,0,0,0-9.53,3.89c-.84.74.39,2,1.24,1.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.82,107.74a8.52,8.52,0,0,1,12.53-.25c.78.8,2-.44,1.23-1.24a10.28,10.28,0,0,0-15,.26c-.75.83.48,2.06,1.24,1.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.52,124c-.14,0-.26-.56-.26-1.25s.11-1.25.26-1.25.26.56.26,1.25S317.66,124,317.52,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.53,133.86a6.18,6.18,0,0,1-.26-2.47,6,6,0,0,1,.26-2.47,6.14,6.14,0,0,1,.26,2.47A6,6,0,0,1,317.53,133.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.55,143.74a6,6,0,0,1-.27-2.47,6.18,6.18,0,0,1,.26-2.47,6.18,6.18,0,0,1,.26,2.47A6,6,0,0,1,317.55,143.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.56,153.63a6.21,6.21,0,0,1-.26-2.48,6.29,6.29,0,0,1,.25-2.47,5.88,5.88,0,0,1,.27,2.47A6.21,6.21,0,0,1,317.56,153.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.07,161.06a6.42,6.42,0,0,1,2.5-.27h0l-.26.26h0v-1c0-.3,0-.57.05-.79.05-.45.12-.73.19-.73s.14.28.18.73c0,.22.05.49.06.79l0,.47V161h0c-.11.12.26-.26-.26.26h0A6,6,0,0,1,315.07,161.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.06,161.09a5.25,5.25,0,0,1,2.25-.27,5,5,0,0,1,2.25.26,10.05,10.05,0,0,1-4.5,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,161.12a4.94,4.94,0,0,1,2.26-.27,5.25,5.25,0,0,1,2.25.25,4.92,4.92,0,0,1-2.25.27A5.28,5.28,0,0,1,297,161.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,161.14a5.16,5.16,0,0,1,2.25-.26,5.11,5.11,0,0,1,2.26.25,5.28,5.28,0,0,1-2.26.27A5,5,0,0,1,288,161.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,163.66a6.27,6.27,0,0,1-.26-2.5c.52-.52.15-.14.26-.26h1c.3,0,.57,0,.79.06.45,0,.73.11.73.18s-.28.13-.73.18c-.22,0-.49,0-.79.06l-.47,0H281c.11-.11-.26.26.25-.26A6.07,6.07,0,0,1,281,163.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,173.83a12.54,12.54,0,0,1,0-5.08,12.54,12.54,0,0,1,0,5.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,184a12.54,12.54,0,0,1,0-5.08,12.54,12.54,0,0,1,0,5.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,194.17a12.54,12.54,0,0,1,0-5.08,12.54,12.54,0,0,1,0,5.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,201.75c-.14,0-.26-.56-.26-1.25s.12-1.25.26-1.25.26.56.26,1.25S281.17,201.75,281,201.75Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.2,426.77l3.74-6.93L198,412.75l-5.58,10.08.77.49c3.46,2.16,17.75,10.72,20.53,11.3C216.83,435.27,207.2,426.77,207.2,426.77Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.17,425.3a5.19,5.19,0,0,0-.14-3.66,5,5,0,0,0-2.51-2.6l-2,3.61Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.8,431.12s3.24,3.22,2.41,3.59-15.59-7.73-21.79-11.88l.18-.28,17.14,9.61S211,430.74,211.8,431.12Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.4,422.43l.21.15.62.39,2.29,1.39c1.95,1.16,4.66,2.73,7.69,4.4s5.8,3.11,7.83,4.13c.94.48,1.75.87,2.4,1.2l.66.31.23.1s-.07-.05-.22-.13l-.64-.34-2.38-1.25c-2-1-4.77-2.51-7.8-4.18s-5.74-3.22-7.7-4.35l-2.33-1.34-.63-.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.63,432.35a6.3,6.3,0,0,1,1.05-.88A6.58,6.58,0,0,1,212,431a2,2,0,0,0-1.39.31A1.94,1.94,0,0,0,209.63,432.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.87,428.32c0,.05.33-.07.68-.27s.62-.38.6-.43a1.6,1.6,0,0,0-.68.27C207.12,428.09,206.85,428.28,206.87,428.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.13,427.2a1.25,1.25,0,0,0,.62-.06c.34-.08.6-.18.59-.23a1.29,1.29,0,0,0-.63.06C206.38,427.05,206.12,427.15,206.13,427.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.14,425.61s.26.25.63.46a1.78,1.78,0,0,0,.71.3s-.26-.25-.63-.46A1.78,1.78,0,0,0,206.14,425.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.38,424.63a1.59,1.59,0,0,0,.64.63,1.48,1.48,0,0,0,.83.32c0-.05-.34-.21-.74-.47S206.42,424.59,206.38,424.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.93,427.44a3,3,0,0,0,.84.45,5.65,5.65,0,0,0,1,.29,2.86,2.86,0,0,0,.62.07.54.54,0,0,0,.35-.15.37.37,0,0,0,.05-.4,1.74,1.74,0,0,0-2.7-.18c-.11.12-.16.2-.15.21a2.86,2.86,0,0,1,.77-.5,1.68,1.68,0,0,1,1-.07,1.49,1.49,0,0,1,1,.61c.07.17-.06.3-.26.3a2.75,2.75,0,0,1-.57-.05,7.29,7.29,0,0,1-1-.25C208.26,427.58,208,427.41,207.93,427.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.12,427.6a1,1,0,0,0,.42-.53,1.51,1.51,0,0,0,.1-.73.93.93,0,0,0-.46-.8.37.37,0,0,0-.46.24,1,1,0,0,0-.07.45,2.92,2.92,0,0,0,.12.72,1.34,1.34,0,0,0,.29.59,6.12,6.12,0,0,0-.17-.62,3.49,3.49,0,0,1-.07-.69c0-.24.08-.6.31-.52s.31.41.35.65a1.6,1.6,0,0,1-.06.67A3.29,3.29,0,0,1,208.12,427.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.61,419s.39.17.93.56a4.75,4.75,0,0,1,1.62,2,4.8,4.8,0,0,1,.29,2.56c-.11.66-.29,1-.26,1s.06-.08.14-.26a3.54,3.54,0,0,0,.24-.77,4.52,4.52,0,0,0-.25-2.65,4.63,4.63,0,0,0-1.7-2,5,5,0,0,0-.72-.37A.8.8,0,0,0,194.61,419Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.9,414.39a28.74,28.74,0,0,0-1.57,2.6,28,28,0,0,0-1.41,2.68,27.65,27.65,0,0,0,1.57-2.59A24,24,0,0,0,198.9,414.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.49,424.93a8,8,0,0,0,1.78,1.23,7.84,7.84,0,0,0,2,.88s-.85-.46-1.88-1S199.52,424.89,199.49,424.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,423.54s0,.21,0,.45-.06.44,0,.46.18-.16.2-.44S197,423.52,197,423.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.65,421.82c-.05,0,0,.2,0,.41s.15.36.2.35,0-.19,0-.4S196.7,421.81,196.65,421.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.58,420.53c0,.05.16.14.31.31s.24.35.29.34,0-.25-.15-.46S195.59,420.48,195.58,420.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.75,419.74s0,.14.09.24.18.16.22.12,0-.14-.09-.24S194.79,419.71,194.75,419.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.49,416.94l20.25,9.4L249,361.63c4.73-17.07,9.29-77.16,9.29-77.16l-26.25,2s-4.05,43.14-10.4,65.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.93,420a20.37,20.37,0,0,1-3.09-1.23c-1.87-.82-4.45-2-7.29-3.31s-5.38-2.53-7.22-3.44a20.34,20.34,0,0,1-2.93-1.57,22,22,0,0,1,3.08,1.23c1.88.82,4.46,2,7.29,3.31s5.4,2.54,7.23,3.45A21.07,21.07,0,0,1,215.93,420Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.53 304.15 250.79 353.48 252.85 342.54 234.53 304.15",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,422.6l-4.12-6.71-12.63,7.63,5.92,9.89.81-.43c3.61-1.91,18.18-10,20.08-12.09C325.14,418.54,313,422.6,313,422.6Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.65,430.54a5.13,5.13,0,0,0-3.24-1.72,5,5,0,0,0-3.5.87l2.13,3.53Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,420.8s4.42-1.18,4.32-.28-14.51,9.6-21.21,12.89l-.15-.3,16.91-10S318.31,421.28,319,420.8Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.78,433.22l.23-.1c.19-.11.41-.22.65-.34l2.35-1.29c2-1.1,4.7-2.66,7.66-4.44s5.61-3.46,7.51-4.7l2.24-1.48.6-.41.2-.15a.75.75,0,0,0-.22.12l-.62.38-2.27,1.44c-1.92,1.21-4.57,2.86-7.53,4.65s-5.67,3.35-7.63,4.48l-2.33,1.34-.63.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,423.3a3.92,3.92,0,0,1,0-2.7,2,2,0,0,0-.43,1.35A2,2,0,0,0,319,423.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.14,423.66a1.58,1.58,0,0,0,.1-.72c0-.41,0-.73-.07-.73a1.51,1.51,0,0,0-.11.72A1.49,1.49,0,0,0,314.14,423.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,423.74s.16-.24.26-.57a1.27,1.27,0,0,0,.1-.62s-.17.24-.27.57S312.74,423.72,312.79,423.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.42,422.93c0,.05.34-.09.71-.31s.64-.42.62-.47a1.77,1.77,0,0,0-.71.32C311.67,422.68,311.4,422.89,311.42,422.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.69,422.23a1.55,1.55,0,0,0,.87-.23c.44-.23.73-.53.69-.56a5,5,0,0,0-.77.4A5.14,5.14,0,0,0,310.69,422.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.9,422.3a2.71,2.71,0,0,0,.81-.49,6.13,6.13,0,0,0,.75-.72,3,3,0,0,0,.37-.5.51.51,0,0,0,.05-.37.38.38,0,0,0-.32-.25,1.74,1.74,0,0,0-1.58,1.54,1.76,1.76,0,0,0,.06.7.61.61,0,0,0,.11.24,3.09,3.09,0,0,1,0-.92,1.71,1.71,0,0,1,.42-.87,1.49,1.49,0,0,1,1-.52c.19,0,.23.2.14.38a2.94,2.94,0,0,1-.34.47,7,7,0,0,1-.7.72C314.19,422.09,313.88,422.28,313.9,422.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.13,422.21s0-.27-.24-.62a1.64,1.64,0,0,0-.58-.46,1,1,0,0,0-.93,0,.38.38,0,0,0,0,.52.93.93,0,0,0,.36.28,2.48,2.48,0,0,0,.67.26,1.35,1.35,0,0,0,.67.05s-.25-.05-.63-.17a3.06,3.06,0,0,1-.63-.28c-.22-.1-.48-.37-.3-.53a.84.84,0,0,1,.74,0,1.45,1.45,0,0,1,.55.38A3.67,3.67,0,0,1,314.13,422.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,429.61s.34-.25.95-.53a4.79,4.79,0,0,1,2.55-.39,4.84,4.84,0,0,1,2.35,1c.52.43.76.78.79.76s0-.1-.16-.26a3.85,3.85,0,0,0-.55-.59,4.44,4.44,0,0,0-5-.66,3.66,3.66,0,0,0-.69.43C300,429.53,299.94,429.6,300,429.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.09,423.57a50.05,50.05,0,0,0,3.06,5.23,22,22,0,0,0-1.45-2.66A25.55,25.55,0,0,0,298.09,423.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.5,428.35a8.75,8.75,0,0,0,1.95-.93,8.92,8.92,0,0,0,1.76-1.26s-.83.5-1.85,1.11S307.47,428.3,307.5,428.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,429.84c0,.05.17.13.37.27s.35.28.39.25-.06-.24-.29-.4S305,429.79,305,429.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.38,429.24c0,.05.15.13.36.19s.39.05.41,0-.15-.13-.36-.19S303.4,429.19,303.38,429.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.73,429.52s.2-.07.43-.12.41,0,.43-.07-.19-.16-.47-.1S301.69,429.49,301.73,429.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.63,429.84c0,.05.12.07.25.05s.22-.08.22-.13-.12-.07-.25-.05S300.62,429.79,300.63,429.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.09,260.29c-.49,0-5.86,15.92-.69,26.47.52,1.06,4.57,6.87,4.57,6.87,14.31,16.89,28.81,49.63,32.85,58.23,8.31,17.65,38.91,75.69,38.91,75.69l19.66-11.25-28.74-73.9-26.09-66.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.54,328.56s1.39,6.73,2.11,6.33c2.05-1.1,16.12-6.35,16.12-6.35l-3.8-4.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.7,333.79s2.63,10.83,6,10.23,10.47-4.14,10.47-4.14l-4.27-10.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.69 333.79 271.92 329.19 272.61 330.91 260.16 335.47 259.69 333.79",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.62,303.5a11.26,11.26,0,0,1,.78,1.49c.51,1,1.17,2.43,2,4.1,1.74,3.53,4.06,8.26,6.63,13.49s4.92,10.06,6.5,13.57c.8,1.76,1.42,3.18,1.84,4.18a12.17,12.17,0,0,1,.6,1.56,9.24,9.24,0,0,1-.79-1.48c-.5-1.05-1.17-2.43-2-4.1-1.74-3.53-4.06-8.26-6.63-13.5s-4.91-10.06-6.5-13.57c-.79-1.75-1.42-3.18-1.84-4.17A9.08,9.08,0,0,1,232.62,303.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.92,412.86c.06.13-4.47,2.54-10.14,5.38s-10.3,5-10.37,4.91,4.48-2.53,10.14-5.37S313.86,412.73,313.92,412.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.48,191.66s-17-6.81-18.43-5.85-10.54,15.86-2.11,17.09,21.47-9.15,21.47-9.15Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.8,192.21a2.3,2.3,0,0,1-.65.46,7.18,7.18,0,0,1-2,.76,11.38,11.38,0,0,1-7-.87,22.42,22.42,0,0,1-5.84-4.06,13.27,13.27,0,0,1-2.05-2.1,19.79,19.79,0,0,1,2.29,1.82,26,26,0,0,0,5.81,3.86,11.83,11.83,0,0,0,6.75,1A17.47,17.47,0,0,0,241.8,192.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.83,225.36l1.45-3a28.85,28.85,0,0,0,2.54-5,8.3,8.3,0,0,0,.59-2.74,12.44,12.44,0,0,0-.19-3.48c-.31-1,.79-1.9,1.57-1.31s1.71,3.39,1.24,6.82,3.51-.29,5-1.62l3.71,12.76-9.26,6.21Z",
    style: {
      fill: "#e6bbac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.83,193.51c-1.08,0-2.36,7.81-3.44,21.83-1.23,15.91-1.13,32,3.28,42.07a8.76,8.76,0,0,0,4.62,4.89c11.39,4.7,42.81-29,42.81-29l-7.73-13.57-22.13,17.87s-2.21-18.08-1.78-26.41C272.78,204.88,266.46,193.58,256.83,193.51Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.83,193.51c-1.08,0-2.36,7.81-3.44,21.83-1.23,15.91-1.13,32,3.28,42.07a8.76,8.76,0,0,0,4.62,4.89c11.39,4.7,42.81-29,42.81-29l-7.73-13.57-22.13,17.87s-2.21-18.08-1.78-26.41C272.78,204.88,266.46,193.58,256.83,193.51Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "270.92 301.22 281.02 297.86 266.82 201.75 261.2 278.74 270.92 301.22",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.92 301.22 281.02 297.86 266.82 201.75 261.2 278.74 270.92 301.22",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.56,274.41a8.79,8.79,0,0,1-.33-1.56c-.18-1-.41-2.47-.69-4.29-.54-3.62-1.2-8.64-1.76-14.21s-.9-10.62-1.1-14.28c-.09-1.83-.15-3.31-.18-4.34a8.5,8.5,0,0,1,0-1.59,10.45,10.45,0,0,1,.19,1.58c.09,1.11.21,2.57.35,4.32.29,3.66.69,8.7,1.25,14.26s1.16,10.58,1.61,14.21c.21,1.75.39,3.2.52,4.31A9.75,9.75,0,0,1,277.56,274.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.46,237.1a10.28,10.28,0,0,1-1.45-1.87c-.84-1.21-1.94-2.9-3.09-4.82s-2.13-3.69-2.8-5a9.83,9.83,0,0,1-1-2.17,12.66,12.66,0,0,1,1.29,2c.85,1.43,1.84,3.08,2.92,4.91l3,4.89A11.7,11.7,0,0,1,300.46,237.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.66,209.84a21.1,21.1,0,0,1-3.44.11h-.35l.15-.32c.24-.55.51-1.11.77-1.7l.19-.4.26.37.64.92.14.2-.45,0,1.28-2.57.32-.64.11.7a19.94,19.94,0,0,1,.38,3.3,29.52,29.52,0,0,1-.83-3.22l.43.06-1.22,2.6-.2.4-.25-.37-.14-.19c-.21-.32-.43-.63-.63-.93l.44,0c-.29.58-.56,1.14-.83,1.67l-.2-.33A34.25,34.25,0,0,1,266.66,209.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.09,210.66c0,.14-.87.26-1.94.26s-1.93-.12-1.93-.26.87-.27,1.93-.27S267.09,210.51,267.09,210.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.83,195.51s-10.05,4.6-15,12.15-2.41,74.82-2.41,74.82L266.15,284s-4-88.58-6.44-89.54C253.58,192,246,192,235.83,195.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,219.74c-.05,2.28-3.66,84.41-3.66,84.41l38.68-.06L241.25,193.61S216.9,197.56,216.4,219.74Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.38,284.29a90.59,90.59,0,0,1-9.62.35,87.27,87.27,0,0,1-9.63-.17,90.4,90.4,0,0,1,9.62-.35A90.34,90.34,0,0,1,241.38,284.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.48,303.85a11.1,11.1,0,0,1-.12-1.56c0-1.1-.09-2.54-.15-4.27-.13-3.6-.33-8.58-.65-14.07s-.71-10.45-1-14.05c-.14-1.72-.26-3.15-.34-4.25a8.44,8.44,0,0,1-.07-1.57,8.73,8.73,0,0,1,.27,1.55c.14,1,.31,2.45.5,4.24.39,3.59.83,8.55,1.16,14.05s.46,10.48.49,14.09c0,1.81,0,3.27,0,4.27A8.18,8.18,0,0,1,246.48,303.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45,287.36c-.07,0,.23-.39.8-.18a.94.94,0,0,1,0,1.8,1,1,0,0,1-1.2-.28,1.07,1.07,0,0,1-.15-1c.18-.55.61-.61.61-.55s-.22.24-.25.63a.58.58,0,0,0,.8.68.53.53,0,0,0,.38-.49.67.67,0,0,0-.32-.49C247.76,287.29,247.49,287.43,247.45,287.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35,267.91c0,.07-.19.18-.23.49s.14.68.56.54a.44.44,0,0,0,.15-.77c-.22-.22-.46-.19-.48-.26s.26-.28.69,0a.84.84,0,0,1-.2,1.56.84.84,0,0,1-1.07-1.16C246,267.83,246.36,267.84,246.35,267.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.42,241.59a2.25,2.25,0,0,1-.07-.48c0-.37-.08-.82-.13-1.36-.09-1.27-.22-3-.38-5-.31-4.25-.77-10.11-1.35-16.59s-1.17-12.32-1.62-16.56c-.21-2-.39-3.75-.52-5,0-.54-.09-1-.12-1.37a1.76,1.76,0,0,1,0-.48,1.46,1.46,0,0,1,.11.47c.06.37.14.81.22,1.35.18,1.18.42,2.89.69,5,.54,4.23,1.19,10.08,1.77,16.56s1,12.35,1.2,16.6c.11,2.13.18,3.85.21,5.05,0,.54,0,1,0,1.37A1.52,1.52,0,0,1,242.42,241.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.48,193a20.06,20.06,0,0,1-2.93,1.07,64.48,64.48,0,0,0-7,2.69,27.64,27.64,0,0,0-6.29,4c-1.44,1.26-2.18,2.2-2.25,2.14s.13-.28.46-.71a13.68,13.68,0,0,1,1.55-1.7,23.67,23.67,0,0,1,6.3-4.2,46.77,46.77,0,0,1,7.12-2.57A17.09,17.09,0,0,1,241.48,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.52 218.12 287.08 196.9 288.57 198.32 271.2 219.7 269.52 218.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.92,217s2.77-7.84,3.39-9.52,1.68-4.58,2.1-4.65,2,.12.1,5.12,2.45,1.85,2.45,1.85l3.82-4.37s3.83,10.2,2,13.3a53.34,53.34,0,0,1-5.24,7Z",
    style: {
      fill: "#e6bbac"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.1 225.11 274.63 231.06 266.87 221.14 270.92 217.03 280.1 225.11",
    style: {
      fill: "#e6bbac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.43,201.82c-1.14.28-8.57,7.47-8.68,22.84-.09,12.21.85,39.34,9.19,43.37,3.78,1.83,9.51,1.79,14.49-1.42,14-9.08,38.89-38.31,38.89-38.31L268.2,216.45s-28.89,29.39-30.12,28.31c-1.86-1.62-1.57-16.88-3.15-30.76C233.81,204.14,232.49,200.06,225.43,201.82Z",
    style: {
      fill: "#31859B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.83,260.93a3,3,0,0,1-.42.48,17.45,17.45,0,0,1-1.33,1.28,26.05,26.05,0,0,1-5.65,3.74A22.28,22.28,0,0,1,236,268a13.5,13.5,0,0,1-5.41.24,11.76,11.76,0,0,1-5.36-2.62,16.58,16.58,0,0,1-3.95-5.05,32.65,32.65,0,0,1-3.23-11.85c-.49-3.74-.84-7.13-1-10s-.28-5.15-.3-6.75c0-.8,0-1.42,0-1.84a2.89,2.89,0,0,1,0-.64,3,3,0,0,1,.07.64q0,.7.09,1.83c.08,1.6.2,3.9.46,6.73s.64,6.21,1.15,9.94a52.71,52.71,0,0,0,1,5.8,26.29,26.29,0,0,0,2.21,5.88,16.3,16.3,0,0,0,3.82,4.9,11.17,11.17,0,0,0,5.12,2.53,13,13,0,0,0,5.22-.18,21.52,21.52,0,0,0,4.35-1.53,27.47,27.47,0,0,0,5.68-3.56C247.18,261.54,247.79,260.89,247.83,260.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.2,216.45a5.79,5.79,0,0,1-.52.63c-.36.39-.88,1-1.58,1.73-1.38,1.49-3.43,3.6-6,6.19s-5.73,5.63-9.27,9l-5.61,5.24c-2,1.79-4,3.68-6.23,5.5l-.38.31,0-.51c-.07-1.08-.14-2.23-.2-3.39-.35-6.07-.68-11.85-1-17.12-.18-2.63-.21-5.14-.47-7.45a18.34,18.34,0,0,0-1.69-6.19,10.44,10.44,0,0,0-3.37-4,8.14,8.14,0,0,0-3.72-1.35,7.2,7.2,0,0,0-3.36.49,3.31,3.31,0,0,1,.82-.38,6.31,6.31,0,0,1,2.56-.31,8.2,8.2,0,0,1,3.86,1.31,10.62,10.62,0,0,1,3.54,4.08,18.45,18.45,0,0,1,1.79,6.31c.28,2.34.33,4.85.51,7.48.32,5.26.66,11,1,17.12.06,1.16.13,2.31.19,3.39l-.41-.2c4.33-3.61,8.25-7.36,11.83-10.66s6.72-6.35,9.34-8.9,4.71-4.62,6.13-6.07L267.6,217A5.23,5.23,0,0,1,268.2,216.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.41,233.21a10.75,10.75,0,0,1-1.72-1.7c-1-1.09-2.38-2.62-3.87-4.33s-2.82-3.28-3.76-4.44a10.46,10.46,0,0,1-1.44-1.94,11.17,11.17,0,0,1,1.71,1.69c1,1.1,2.39,2.63,3.88,4.35s2.82,3.28,3.76,4.44A11.06,11.06,0,0,1,274.41,233.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.17,251.4a17,17,0,0,1,2.65-7.06,20.46,20.46,0,0,1-1.23,3.57A20.19,20.19,0,0,1,236.17,251.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.67,249.44a27.84,27.84,0,0,1,5.59-5.1,13.66,13.66,0,0,1-2.62,2.74A14.2,14.2,0,0,1,233.67,249.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,229a12.7,12.7,0,0,1-1.56-1.81c-.93-1.15-2.22-2.71-3.71-4.39s-2.9-3.14-3.93-4.19a12.84,12.84,0,0,1-1.62-1.76,9.34,9.34,0,0,1,1.88,1.49,55.55,55.55,0,0,1,4.05,4.12,53.56,53.56,0,0,1,3.62,4.5A9.36,9.36,0,0,1,279,229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.85,196s15.69,82.8,15.7,83.6-1.2,68.51-.09,79.34,6.26,76.3,6.26,76.3H325l-4.13-111.4L320.77,271l-13.16-66.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.67,360.92c.08,0-.19,1.19-.47,3.11a42.16,42.16,0,0,0-.41,7.53,41.49,41.49,0,0,0,1,7.49c.42,1.89.78,3,.7,3.06a2.67,2.67,0,0,1-.35-.77,22.74,22.74,0,0,1-.71-2.21,33.78,33.78,0,0,1-1.14-7.55,34.58,34.58,0,0,1,.56-7.61c.19-1,.38-1.73.54-2.25S321.63,360.91,321.67,360.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.28,233.53a6.32,6.32,0,0,1-1.61-1.7,32.72,32.72,0,0,1-2.9-4.81c-1-1.94-1.91-3.71-2.53-5a10.48,10.48,0,0,1-.91-2.14,10.84,10.84,0,0,1,1.24,2c.7,1.25,1.65,3,2.66,4.93a53.26,53.26,0,0,0,2.74,4.84C303.76,232.81,304.34,233.48,304.28,233.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.75,233.91a2,2,0,0,1,.32.35l.85,1.09c.72,1,1.76,2.33,2.94,4.12a38.15,38.15,0,0,1,3.57,6.61,24.67,24.67,0,0,1,1.8,9c0,6.52-.06,12.4-.11,16.67-.05,2.07-.08,3.78-.11,5,0,.55,0,1-.05,1.38a1.58,1.58,0,0,1-.06.48,1.87,1.87,0,0,1,0-.48c0-.38,0-.83,0-1.38,0-1.27,0-3-.06-5,0-4.34,0-10.19,0-16.66a24.83,24.83,0,0,0-1.72-8.87,40.42,40.42,0,0,0-3.44-6.59c-1.14-1.8-2.13-3.22-2.8-4.2A13.34,13.34,0,0,1,306.75,233.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.72,313.47a1.57,1.57,0,0,1-.15-.49c-.08-.39-.19-.86-.32-1.43-.26-1.25-.63-3.05-1.05-5.29a151.74,151.74,0,0,1-2.4-17.64,74.3,74.3,0,0,1,.75-17.79,48.31,48.31,0,0,1,1.19-5.27c.16-.62.33-1.09.43-1.41a2.39,2.39,0,0,1,.19-.47,15.53,15.53,0,0,1-.43,1.93c-.29,1.23-.67,3-1,5.28a81.58,81.58,0,0,0-.59,17.69c.47,6.92,1.5,13.13,2.24,17.61.37,2.19.67,4,.89,5.32.09.58.17,1.06.23,1.45A2,2,0,0,1,320.72,313.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.45,354.17a2.22,2.22,0,0,1,0-.5,9.46,9.46,0,0,1,.09-1.44,19.39,19.39,0,0,1,1.55-5.05,63.37,63.37,0,0,0,3-7.17,23.92,23.92,0,0,0,.36-9.39c-.42-3.35-.82-6.55-1.18-9.47s-.63-5.56-1-7.72a9.57,9.57,0,0,0-1.95-4.74,7.74,7.74,0,0,0-1.47-1.2,2.78,2.78,0,0,1,.47.19,4.76,4.76,0,0,1,1.15.87,9.47,9.47,0,0,1,2.16,4.8c.42,2.21.7,4.83,1.11,7.74s.83,6.1,1.23,9.48a23.74,23.74,0,0,1-.42,9.57,57.31,57.31,0,0,1-3.08,7.19,21.12,21.12,0,0,0-1.69,4.93C315.49,353.48,315.51,354.17,315.45,354.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.58,319.19a3.15,3.15,0,0,1,.36.83,20.73,20.73,0,0,1,.71,2.37,31,31,0,0,1,.83,8.09,30.58,30.58,0,0,1-1.32,8,21.62,21.62,0,0,1-.84,2.31,3.47,3.47,0,0,1-.41.81c-.09,0,.37-1.23.9-3.23a35.33,35.33,0,0,0,.48-15.93C315.88,320.44,315.5,319.22,315.58,319.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.91,401.73a2.32,2.32,0,0,1,0-.58c0-.43.08-1,.14-1.64a35,35,0,0,0-.05-6,21.81,21.81,0,0,0-.82-4.06,37.93,37.93,0,0,0-1.77-4.44,48.87,48.87,0,0,1-2-4.94,27,27,0,0,1-1.16-5.64,39.72,39.72,0,0,1,.59-11,87.07,87.07,0,0,1,2.15-8.75c.73-2.46,1.35-4.44,1.78-5.81l.49-1.57a2.08,2.08,0,0,1,.21-.54,2.25,2.25,0,0,1-.11.57c-.1.42-.24.95-.4,1.6-.4,1.45-.94,3.43-1.61,5.85s-1.46,5.41-2,8.74a40.81,40.81,0,0,0-.54,10.9,26.58,26.58,0,0,0,1.12,5.53,48.58,48.58,0,0,0,2,4.9,38.79,38.79,0,0,1,1.74,4.51,21.15,21.15,0,0,1,.78,4.15,31,31,0,0,1-.12,6.09c-.09.71-.17,1.26-.24,1.64A2.19,2.19,0,0,1,321.91,401.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.7,399.61c.15.06-1.08,3.14-1.87,7.13s-.88,7.31-1,7.31a7.63,7.63,0,0,1-.09-2.18,32.72,32.72,0,0,1,2.07-10.29A7.71,7.71,0,0,1,323.7,399.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.52,238.65s-.29-.28-.73-.85-1.06-1.42-1.79-2.49a74.39,74.39,0,0,1-8.87-18.11c-.4-1.23-.69-2.23-.87-2.93a5.06,5.06,0,0,1-.23-1.1,5.09,5.09,0,0,1,.42,1c.28.78.63,1.74,1,2.87a96.17,96.17,0,0,0,3.94,9.25,97.4,97.4,0,0,0,4.89,8.78l1.65,2.57A4.69,4.69,0,0,1,315.52,238.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.8,215.37a11.25,11.25,0,0,1-1.65-1.69l-3.79-4.22-3.78-4.22a11.39,11.39,0,0,1-1.5-1.83,10.06,10.06,0,0,1,1.76,1.57c1,1,2.43,2.48,3.91,4.13s2.77,3.19,3.68,4.33A10.73,10.73,0,0,1,311.8,215.37Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M310.42,215.48s-4.54,6.86-2.77,7.18,4.44-5.42,4.26-6.33S310.42,215.48,310.42,215.48Z",
    style: {
      fill: "#e6bbac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.43,218.49s-4.53,6.86-2.76,7.19,4.43-5.42,4.26-6.33S311.43,218.49,311.43,218.49Z",
    style: {
      fill: "#e6bbac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.77,222.67s-4.54,6.86-2.77,7.18,4.44-5.42,4.26-6.33S312.77,222.67,312.77,222.67Z",
    style: {
      fill: "#e6bbac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.87,165.36c.75,4.76.71,8.93-1.61,12a18.33,18.33,0,0,0-1.4,1.88,2.89,2.89,0,0,0-.36,2.25,2,2,0,0,0,3.4.68,2.74,2.74,0,0,0,1.33,2.75,1.73,1.73,0,0,0,2.44-1.25s-.62,2.4,2.14,2l-1.94-16.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.31,201.91h0A7.71,7.71,0,0,0,257,193.4c-.26-2.47-.48-4.48-.48-4.48s6.09-.95,6.16-7-1-20.07-1-20.07h0a21.15,21.15,0,0,0-21.26,2.67l-.91.7,2.12,29.58A7.7,7.7,0,0,0,249.31,201.91Z",
    style: {
      fill: "#e6bbac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.07,172.81a.88.88,0,1,1,1.25-.06A.89.89,0,0,1,260.07,172.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.76,170.88c-.1.11-.7-.35-1.53-.35s-1.45.43-1.55.32.05-.24.32-.44a2.06,2.06,0,0,1,2.45,0C261.71,170.65,261.8,170.84,261.76,170.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.09,172.15a.88.88,0,1,1-1.21.29A.87.87,0,0,1,252.09,172.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.65,171.62c-.1.11-.7-.35-1.53-.36s-1.45.43-1.54.33,0-.24.31-.44a2,2,0,0,1,1.23-.39,2,2,0,0,1,1.22.42C252.6,171.38,252.69,171.58,252.65,171.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,178.54a4.24,4.24,0,0,1,1.36-.29c.22,0,.39-.07.4-.19a1.16,1.16,0,0,0-.15-.62l-.67-1.71a23,23,0,0,1-1.43-4.48,23.72,23.72,0,0,1,1.88,4.31c.22.6.42,1.16.63,1.72a1.42,1.42,0,0,1,.12.91.57.57,0,0,1-.38.35,1.05,1.05,0,0,1-.37.05A4,4,0,0,1,256,178.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29,179.47c-.88-.52,2.4,1.28,4.11,1.19a2.33,2.33,0,0,1-2.74.93C252.84,180.92,253.29,179.47,253.29,179.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.51,188.83a14.18,14.18,0,0,1-7.94-2.26s1.87,4.39,7.95,3.84Z",
    style: {
      fill: "#d88876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.5,171.07c-.13,0-4.54-.34-3.81,4.79s5.68,2.7,5.66,2.55S239.5,171.07,239.5,171.07Z",
    style: {
      fill: "#e6bbac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.53,176.83s-.09.08-.23.17a.88.88,0,0,1-.66.11,2.25,2.25,0,0,1-1.31-1.84,3,3,0,0,1,.07-1.32,1.06,1.06,0,0,1,.57-.78.48.48,0,0,1,.57.17c.09.14.07.24.1.25s.09-.1,0-.31a.52.52,0,0,0-.25-.29.63.63,0,0,0-.51-.06,1.26,1.26,0,0,0-.82.93,3,3,0,0,0-.11,1.47,2.35,2.35,0,0,0,1.62,2,1,1,0,0,0,.8-.25C239.53,177,239.54,176.84,239.53,176.83Z",
    style: {
      fill: "#d88876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.27,161.22a2,2,0,0,0-2.28-1.63,2.28,2.28,0,1,0-1.51-4.15,6.83,6.83,0,0,0,1.6-2.29,2.3,2.3,0,0,0-.59-2.57,2.54,2.54,0,0,0-2.63,0c-1.26.62-2.21,1.78-3.5,2.32s-2.79.4-4.2.55a7.57,7.57,0,0,0-4.28,1.78,5.05,5.05,0,0,0-1.7,4.2c-1.92-.12-4,0-5.51,1.19A4.42,4.42,0,0,0,237,156.5a5.62,5.62,0,0,0-5.47-.54,3.2,3.2,0,0,0-1.89,1.76,3.24,3.24,0,0,0,1.28,3.25,7.32,7.32,0,0,0,6.4,1.54,6.59,6.59,0,0,0-.44,2.85c.1,1.68,1.45,3.42,2,5h0l.13,1,1,4.3,2.69-.22-.73-9s-.51-3.79,2.8-3.66,8,3.56,14.33,2.23a7,7,0,0,0,2.93-1A2.94,2.94,0,0,0,263.27,161.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.8,165.19c0-.08.69.24,1.82.41a7.29,7.29,0,0,0,4.28-.63,7.4,7.4,0,0,0,3.13-3c.55-1,.7-1.71.78-1.69a3.45,3.45,0,0,1-.46,1.85,6.86,6.86,0,0,1-7.8,3.83A3.57,3.57,0,0,1,227.8,165.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.26,170.21c-.06,0-.27-.51-.18-1.39a7.57,7.57,0,0,1,1.19-3.14c.68-1.11,1.36-2,1.75-2.77a7.41,7.41,0,0,1,.66-1.19c.07,0,0,.55-.33,1.35a22,22,0,0,1-1.64,2.88,9.39,9.39,0,0,0-1.27,2.93C234.27,169.67,234.34,170.2,234.26,170.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.13,160c.13,0-.07.95-.8,1.81s-1.6,1.2-1.66,1.08.61-.64,1.26-1.42S239,160,239.13,160Z",
    style: {
      fill: "#31859B"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdr);
export default __webpack_public_path__ + "static/media/sdr.45c8534210902a28f85cf40be4ece24f.svg";
export { ForwardRef as ReactComponent };